module.exports = __webpack_public_path__ + "img/left-bg.36bbe717.png";